/*
 * @Author: Girish Akhare
 * @Date: 2022-01-21 10:48:01
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-03-09 15:23:55
 */
import {
  Directive,
  Output,
  EventEmitter,
  HostBinding,
  HostListener
} from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[appDndCustom]'
})
export class DndDirective {
  @HostBinding('class.fileover')
  fileOver: boolean;
  @Output()
  fileDropped = new EventEmitter<any>();

  // Dragover listener
  @HostListener('dragover', ['$event'])
  onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Drop listener
  @HostListener('drop', ['$event'])
  public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
